import { DocumentTypeEnum } from '@/types/generated'

export const documentTypesDE = {
  [DocumentTypeEnum.ANFRAGE]: 'Anfrage',
  [DocumentTypeEnum.E_MAIL]: 'E-Mail',
  [DocumentTypeEnum.UPLOAD]: 'Upload',
  [DocumentTypeEnum.FRAGEBOGEN]: 'Fragebogen',
  [DocumentTypeEnum.DOKUMENTENVORLAGE]: 'Dokumentenvorlage',
  [DocumentTypeEnum.TRANSKRIPT]: 'Transkript',
  [DocumentTypeEnum.KI_DOKUMENTENGENERATOR_VORLAGE]: 'KI Dokumentengenerator Vorlage',
  [DocumentTypeEnum.KI_GENERIERTES_DOKUMENT]: 'KI generiertes Dokument',
  [DocumentTypeEnum.KI_CHAT]: 'KI Chat'
}

export const documentTypesEN = {
  [DocumentTypeEnum.ANFRAGE]: 'Request',
  [DocumentTypeEnum.E_MAIL]: 'E-Mail',
  [DocumentTypeEnum.UPLOAD]: 'Upload',
  [DocumentTypeEnum.FRAGEBOGEN]: 'Questionnaire',
  [DocumentTypeEnum.DOKUMENTENVORLAGE]: 'Document template',
  [DocumentTypeEnum.TRANSKRIPT]: 'Transcript',
  [DocumentTypeEnum.KI_DOKUMENTENGENERATOR_VORLAGE]: 'AI document generator template',
  [DocumentTypeEnum.KI_GENERIERTES_DOKUMENT]: 'AI generated document',
  [DocumentTypeEnum.KI_CHAT]: 'AI Chat'
}
